import React from "react";
import { telemetryService } from "../../services/TelemetryService";
import DeviceCommsTable from "./DeviceCommsTable";

import { Button, Grid, TextField } from "@mui/material";

class DeviceComms extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            loading: false,
            deviceId: null,
            receivedCalls: [],
            numCalls: 10,
            inputError: false,
            emptyResponse: false,
            deviceType: "edge",
        };
    }

    fetchRtuCalls = (e) => {
        e.preventDefault();

        this.setState({ loading: true, emptyResponse: false, receivedCalls: [] });

        let { deviceId, deviceType } = this.state;

        if (this.validateRtuId(deviceId) && deviceType) {
            this.setState({ inputError: false });

            telemetryService.getEdgeCallIns(deviceId, "v3").then((data) => {
                if (data?.length) {
                    this.setState({ receivedCalls: data, loading: false });
                } else {
                    this.setState({ emptyResponse: true, loading: false });
                }
            });
        } else {
            this.setState({ inputError: true, loading: false });
        }
    };

    handleChange = (e) => {
        let deviceId = e.target.value;
        let { inputError } = this.state;

        if (inputError && this.validateRtuId(deviceId)) {
            this.setState({ inputError: false });
        }

        this.setState({ deviceId });
    };

    validateRtuId = (id) => {
        return id?.length >= 3 && Number(id);
    };

    handleTypeChange = (event) => {
        this.setState({ deviceType: event.target.value });
    };

    render() {
        let { receivedCalls, loading, emptyResponse, deviceType } = this.state;

        return (
            <div style={{ marginTop: "1.5rem" }}>
                <Grid container>
                    <Grid item xs={12} md={12}>
                        <TextField
                            id="outlined-basic"
                            label="Edge Device ID"
                            variant="outlined"
                            InputLabelProps={{ shrink: true }}
                            onChange={this.handleChange}
                            error={this.state.inputError}
                            helperText={this.state.inputError ? "Device ID must contain at least 3 digits." : ""}
                            onKeyPress={(ev) => {
                                if (ev.key === "Enter") {
                                    ev.preventDefault();
                                }
                            }}
                        />

                        <Button variant="contained" color="primary" size="large" onClick={this.fetchRtuCalls}>
                            Go
                        </Button>
                    </Grid>
                    <Grid item xs={12}>
                        <DeviceCommsTable
                            loading={loading}
                            receivedCalls={receivedCalls}
                            emptyResponse={emptyResponse}
                        />
                    </Grid>
                </Grid>
            </div>
        );
    }
}

export default DeviceComms;
